import { render, staticRenderFns } from "./AdvancedKanban.vue?vue&type=template&id=9b4ab91e&scoped=true&"
import script from "./AdvancedKanban.vue?vue&type=script&lang=ts&"
export * from "./AdvancedKanban.vue?vue&type=script&lang=ts&"
import style0 from "./AdvancedKanban.vue?vue&type=style&index=0&id=9b4ab91e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4ab91e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VChip,VDivider,VIcon})
